@if (isLoadingTeacher()) {
  <app-shimmer-effect />
} @else if (teacher()) {
<!--  <section class="page-heading">-->
<!--    <div>-->
<!--      <h4>{{ teacherName() }}</h4>-->
<!--      <small>Teacher details and the subjects they teach</small>-->
<!--    </div>-->
<!--  </section>-->

  <section class="class-container">
    <div class="box-one">
      <div class="class-details teacher-card">
        <div class="heading">
          <div>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.6667 17.5V15.8333C16.6667 14.9493 16.3155 14.1014 15.6904 13.4763C15.0653 12.8512 14.2174 12.5 13.3333 12.5H6.66667C5.78261 12.5 4.93476 12.8512 4.30964 13.4763C3.68452 14.1014 3.33333 14.9493 3.33333 15.8333V17.5"
                stroke="white"
                stroke-width="1.41667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10 9.16667C11.8409 9.16667 13.3333 7.67428 13.3333 5.83333C13.3333 3.99238 11.8409 2.5 10 2.5C8.15905 2.5 6.66667 3.99238 6.66667 5.83333C6.66667 7.67428 8.15905 9.16667 10 9.16667Z"
                stroke="white"
                stroke-width="1.41667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <small>Teacher</small>

          <h4>{{ teacherName() }}</h4>

          <small>{{ teacher()?.payload?.public_id }}</small>
        </div>

        <div class="class-numbers">
          <div>
            <small>Status</small>
            <h6 [ngClass]="teacher()?.payload?.status" class="class-status">
              {{ Helpers.replaceUnderscore(teacher()?.payload?.status) }}
            </h6>
          </div>

          <div>
            <small>Staff Number</small>
            <h6>{{ teacher()?.payload?.staff_number || 'N/A' }}</h6>
          </div>

          <div>
            <small>Username</small>
            <h6>{{ teacher()?.payload?.username ? '@' + teacher()?.payload?.username : 'N/A' }}</h6>
          </div>

          <div>
            <small>Employment Type</small>
            <h6>
              {{
                Helpers.capitalizeWords(
                  Helpers.replaceUnderscore(teacher()?.payload?.employment_type)
                )
              }}
            </h6>
          </div>

          <div>
            <small>Specialization</small>
            <h6>{{ teacher()?.payload?.specialization || 'N/A' }}</h6>
          </div>

          <div>
            <small>Phone</small>
            <h6>{{ teacher()?.payload?.phone || 'N/A' }}</h6>
          </div>

          <div>
            <small>Hire Date</small>
            <h6>{{ Helpers.formatDate(teacher()?.payload?.hire_date) }}</h6>
          </div>

          <div>
            <small>Qualifications</small>
            <h6>{{ qualificationText() }}</h6>
          </div>
        </div>
      </div>
    </div>

    <div class="box-two">
      <section class="table-content">
        <div class="class-subject-heading">
          <div class="icon">
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_teacher_subjects)">
                <path
                  d="M11.9117 5.41448V8.66313M11.9117 5.41448L6.4973 2.70728L1.08288 5.41448L6.4973 8.12169L11.9117 5.41448Z"
                  stroke="#5C0B13"
                  stroke-width="0.974595"
                />
                <path
                  d="M3.24865 6.49731V9.20452C4.87297 10.8288 8.12162 10.8288 9.74595 9.20452V6.49731"
                  stroke="#5C0B13"
                  stroke-width="0.974595"
                />
              </g>
              <defs>
                <clipPath id="clip0_teacher_subjects">
                  <rect width="12.9946" height="12.9946" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          <div>
            <h6>Subjects Taught</h6>
            <small>{{ subjectGroups().length }} subject(s) assigned to {{ teacherName() }}</small>
          </div>
        </div>

        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>SUBJECT</th>
                <th>SUBJECT CODE</th>
                <th>LEVEL</th>
                <th>CLASSES</th>
                @if (isAdmin) {
                  <th class="options-column finalize-column">ACTION</th>
                }
              </tr>
            </thead>

            <tbody>
              @if (isLoadingSubjects()) {
                <tr>
                  <td [attr.colspan]="isAdmin ? 5 : 4">
                    <app-loading-indicator />
                  </td>
                </tr>
              } @else if (!subjectGroups().length) {
                <tr>
                  <td [attr.colspan]="isAdmin ? 5 : 4" class="empty">
                    <app-not-found-error> NO SUBJECTS ASSIGNED </app-not-found-error>
                  </td>
                </tr>
              } @else {
                @for (subject of subjectGroups(); track subject.level_subject_id) {
                  <tr>
                    <td>
                      {{ subject.subject_name }}
                    </td>

                    <td>{{ subject.subject_code }}</td>

                    <td>{{ subject.level_name }}</td>

                    <td>
                      <div class="class-list">
                        @for (classItem of subject.classes; track classItem.class_id) {
                          <small>{{ classItem.class_name }}</small>
                        }
                      </div>
                    </td>

                    @if (isAdmin) {
                      <td class="options-column finalize-column">
                        <button
                          type="button"
                          class="button finalize-button"
                          [class.reopen-button]="isSubjectFinalized(subject)"
                          [disabled]="isSubjectConfigLoading(subject)"
                          (click)="openConfirmation(subject)"
                        >
                          @if (isSubjectConfigLoading(subject)) {
                            <app-loading-indicator />
                          } @else if (isSubjectFinalized(subject)) {
                            Reopen Assessment
                          } @else {
                            Finalize Assessment
                          }
                        </button>
                      </td>
                    }
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </section>
} @else {
  <section class="table-content">
    <app-not-found-error> TEACHER NOT FOUND </app-not-found-error>
  </section>
}

@if (showConfirmationPopup()) {
  <section class="pop-up">
    <div class="bg" (click)="cancelConfirmation()"></div>

    <form #confirmationForm="ngForm" (ngSubmit)="confirmAction()">
      <div class="form-heading">
        <div class="image-box">
          @if (popupAction() === 'reopen') {
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.5 7.5C2.5 4.73858 4.73858 2.5 7.5 2.5C9.15007 2.5 10.6178 3.29939 11.5396 4.53281M12.5 7.5C12.5 10.2614 10.2614 12.5 7.5 12.5C5.84993 12.5 4.38219 11.7006 3.46036 10.4672"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M12.5 2.5V5.625H9.375"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          } @else {
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.5 7.5L6 11L12.5 3.75"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
        </div>

        <div>
          <h6>{{ popupAction() === 'reopen' ? 'Reopen Assessment' : 'Finalize Assessment' }}</h6>
          <small>{{ selectedSubject()?.subject_name }} - {{ selectedSubject()?.level_name }}</small>
        </div>
      </div>

      <div class="form-container">
        @if (configError()) {
          <p class="finalize-message config-error">{{ configError() }}</p>
        } @else if (assessmentConfig(); as config) {
          <div class="config-summary">
            <div>
              <small>Status</small>
              <h6 [ngClass]="config.status" class="config-status">
                {{ Helpers.replaceUnderscore(config.status) }}
              </h6>
            </div>

            <div>
              <small>Components</small>
              <h6>{{ config.component_count }}</h6>
            </div>

            <div>
              <small>Results</small>
              <h6>{{ config.result_count }}</h6>
            </div>
          </div>

          @if (popupAction() === 'reopen') {
            <p class="finalize-message">
              Reopening will unlock this assessment so scores can be corrected. The published
              results will no longer be final until the assessment is finalized again.
            </p>

            <div>
              <label for="reopenReason">Reason <span class="required-check">*</span></label>
              <textarea
                id="reopenReason"
                name="reopenReason"
                rows="3"
                [(ngModel)]="reopenReason"
                placeholder="Explain why this assessment needs to be reopened"
              ></textarea>
            </div>
          } @else {
            <p class="finalize-message">
              Finalizing will calculate the final scores for every student, lock this assessment,
              and publish the results to the report card.
            </p>

            <p class="finalize-message">
              Confirm that all recorded scores are correct before continuing.
            </p>
          }
        }

        <div class="unlock-actions">
          <button
            class="button"
            type="button"
            (click)="cancelConfirmation()"
            [disabled]="isProcessing()"
          >
            Cancel
          </button>

          @if (popupAction() === 'reopen') {
            <button class="secondary-button" type="submit" [disabled]="!canReopen">
              @if (isProcessing()) {
                <app-loading-indicator />
              } @else {
                Reopen Assessment
              }
            </button>
          } @else {
            <button class="secondary-button" type="submit" [disabled]="!canFinalize">
              @if (isProcessing()) {
                <app-loading-indicator />
              } @else {
                Finalize Assessment
              }
            </button>
          }
        </div>
      </div>
    </form>
  </section>
}
